let userData = {
  userStates: {
    ok: {
      verboseName: "Active",
      color: "success",
    },
    not_active: {
      verboseName: "Not Active",
      color: "secondary",
    },
    invited: {
      verboseName: "Invited",
      color: "warning",
    },
  },
  allUserTriggers: {
    update_user: {
      verboseName: "Edit User",
      userTrigger: true,
    },
    activate: {
      verboseName: "Activate User",
      userTrigger: true,
    },
    deactivate: {
      verboseName: "Deactivate User",
      userTrigger: true,
    },
  },
};

export { userData };